var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.busy)?_c('div',[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slds-spinner_container slds-is-fixed"},[_c('div',{staticClass:"slds-spinner slds-spinner_medium",attrs:{"role":"status"}},[_c('span',{staticClass:"slds-assistive-text"},[_vm._v("Loading")]),_c('div',{staticClass:"slds-spinner__dot-a"}),_c('div',{staticClass:"slds-spinner__dot-b"})])])
}]

export { render, staticRenderFns }